import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ExtendedReportView from './ExtendedReportView';
import { getOnePagerReport } from '../../../api/projectApi';
import OnePagerReportLoan from '../../Portfolio_R/SummaryCharts/view/OnePagerReportLoan';
import FinancialInfo from './components/FinancialInfo/FinancialInfo';
import PerformanceMonitoring from './components/PerformanceMonitoring/PerformanceMonitoring';
import ExtendedReportLoan from './components/GeneralInformation/ExtendedReportLoan/ExtendedReportLoan';
import DownloadReport from './DownloadReport';

export const ExtendedReportRouter: React.FC = () => (
    <Switch>
        <Route
            exact
            path="/extendedreport/downloadreport"
            component={DownloadReport}
        />

        <Route
            exact
            path="/extendedreport"
            component={ExtendedReportView}
        />

        <Route
            path="/extendedreport/financial-info"
            component={FinancialInfo}
        />
        <Route
            path="/extendedreport/performance-monitoring"
            component={PerformanceMonitoring}
        />
    </Switch>
);
